import React from 'react';
import { InputGroup, InputLeftAddon, Input, Select } from '@chakra-ui/react';

import { COUNTRIES, matchDialCode } from '../validations/PhoneValidations';

const PhoneInput = ({ country, number, onChange }) => {

    const onChangeNumber = (e) => {
        // A pasted/typed "+<code>…" number switches the country automatically
        const matched = matchDialCode(e.target.value);
        if (matched) {
            onChange(matched.country, matched.number);
        } else {
            onChange(country, e.target.value.replace(/[^\d\s-]/g, ''));
        }
    };

    return (
        <InputGroup>
            <InputLeftAddon p={0} bg='gray.50' >
                <Select
                    aria-label='Country code'
                    variant='unstyled'
                    width='110px'
                    pl={3}
                    fontSize={15}
                    value={country}
                    onChange={(e) => onChange(e.target.value, number)}
                >
                    {COUNTRIES.map(c => <option key={c.code} value={c.code}>{c.flag} +{c.dial}</option>)}
                </Select>
            </InputLeftAddon>
            <Input
                type='tel'
                inputMode='tel'
                autoComplete='tel-national'
                maxLength={18}
                placeholder={country === 'IN' ? '10-digit mobile number' : 'Mobile number'}
                value={number}
                onChange={onChangeNumber}
            />
        </InputGroup>
    )
}

export default PhoneInput;
